import ru from "@/lang/ru";
import kk from "@/lang/kk";

export default {
  ru,
  kk,
};
